import { get } from 'lodash';

const styles = theme => ({
  tableContainer: {
    '& tr th:first-child, tr td:first-child': {
      paddingLeft: get(theme, 'padding.p36'),
    },
    '& tr th:last-child, tr td:last-child': {
      paddingRight: get(theme, 'padding.p36'),
    },
    '& caption': {
      color: get(theme, 'color.bodyText'),
      paddingLeft: get(theme, 'padding.p36'),
      paddingRight: get(theme, 'padding.p36'),
      whiteSpace: get(theme, 'whiteSpace.breakSpaces'),
    },
  },
  [`@media (max-width: ${get(theme, 'breakpoint.xs')})`]: {
    tableContainer: {
      '& tr th:first-child, tr td:first-child': {
        paddingLeft: get(theme, 'padding.p16'),
      },
      '& tr th:last-child, tr td:last-child': {
        paddingRight: get(theme, 'padding.p16'),
      },
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/Table/styles.js